export const baseStaticURL = process.env.REACT_APP_STATIC_BASE_URL;
export const baseApiURL = process.env.REACT_APP_BASE_URL_API;

export const loginURL = '/api/v1/auth/user/login';
export const getProfile = '/api/v1/auth/user/get-user';
export const registrationURL = '/api/v1/auth/user/signup';
export const userURL = '/api/v1/auth/user';
export const createBasicProfileURL = '/api/v1/auth/user/update-basic-profile';
export const countryListURL = '/api/v1/country/getAll';
export const stateListURL = '/api/v1/country/getAllStatesByCountryId';
export const cityListURL = '/api/v1/country/getAllCitiesByStateId';
// Shared — used by DX Panelists admin components (AuthAPI.ts)
export const redemptionRequest = '/api/v1/redemptionRequest/getAll';
export const redemptionRespondentRequestURL = '/api/v1/redemptionRequest';
export const rewardsURL = '/api/v1/rewards/getAll'
export const rewardsAPIURL = '/api/v1/rewards'
export const referralsUrl = '/api/v1/referrals'
export const countryURL = '/api/v1/country';
// CP-only URL
// export const redemptionMode = '/api/v1/redemption';
export const partnersURL = '/api/v1/partners';
// CP-only URL
// export const labelsURL = '/api/v1/labels';
// CP-only URL
// export const marketingLinksURL = '/api/v1/marketingLinks';
// CP-only URL
// export const secURL = '/api/v1/sec';
export const profileManagementURL = '/api/v1/profileManagement';
export const questionsURL = '/api/v1/questions';
export const optionsURL = '/api/v1/options';
export const surveysURL = '/api/v1/surveys';
export const samplesURL = '/api/v1/samples';
export const usersListURL = '/api/v1/auth/user';
export const newsLettersURL = '/api/v1/newsLetters';
// CP-only URL
// export const messagesURL = '/api/v1/messages';
export const surveyEmailSchedule = '/api/v1/SurveyEmailSchedule';
export const resendSurveyEmailSchedule = '/api/v1/resendSurveyEmailSchedule';
export const faqUrl = '/api/v1/faq';
export const clientUrl = '/api/v1/clients';
// Audit trail (who-changed-what) — see Controllers/ChangeLog.controller.js
export const changeLogsURL = '/api/v1/changelogs';
export const baristaCouponsURL = '/api/v1/loginTypeReward';




// /api/v1/SurveyEmailSchedule/create





